import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Login from './pages/auth_screen/Login';
import Forgot from './pages/auth_screen/Forgot';
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/home_screen/teacher_screen/Dashboard';
import MyClasses from './pages/home_screen/teacher_screen/MyClasses';
import Assignments from './pages/home_screen/teacher_screen/Assignments';
import Timetable from './pages/home_screen/teacher_screen/Timetable';
import Attendance from './pages/home_screen/teacher_screen/Attendance';
import MyStudent from './pages/home_screen/teacher_screen/MyStudent';
import Exams from './pages/home_screen/teacher_screen/Exams';
import Events from './pages/home_screen/teacher_screen/Events';
import LeaveRequest from './pages/home_screen/teacher_screen/LeaveRequest';
import Settings from './pages/home_screen/teacher_screen/Settings';
import LMS from './pages/home_screen/teacher_screen/LMS';

// Admin Screens
import AdminDashboard from './pages/home_screen/admin_screen/AdminDashboard';
import StudentList from './pages/home_screen/admin_screen/StudentList';
import TeacherList from './pages/home_screen/admin_screen/TeacherList';
import ClassManagement from './pages/home_screen/admin_screen/ClassManagement';
import AdminTimetable from './pages/home_screen/admin_screen/AdminTimetable';
import AdminAttendance from './pages/home_screen/admin_screen/AdminAttendance';
import Examinations from './pages/home_screen/admin_screen/Examinations';
import FeeManagement from './pages/home_screen/admin_screen/FeeManagement';
import Notices from './pages/home_screen/admin_screen/Notices';
import Transport from './pages/home_screen/admin_screen/Transport';
import AdminSettings from './pages/home_screen/admin_screen/AdminSettings';
import AdminLMS from './pages/home_screen/admin_screen/AdminLMS';

// Accountant Screens
import AccountantDashboard from './pages/home_screen/accountant_screen/AccountantDashboard';
import FeeCollection from './pages/home_screen/accountant_screen/FeeCollection';
import AccountantStudents from './pages/home_screen/accountant_screen/AccountantStudents';
import AccountantReports from './pages/home_screen/accountant_screen/AccountantReports';
import AccountantSettings from './pages/home_screen/accountant_screen/AccountantSettings';

function App() {
  return (
    <LanguageProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/landing" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot" element={<Forgot />} />

        {/* Teacher Routes */}
        <Route path="/teacher">
          <Route index element={<Navigate to="/teacher/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="my-classes" element={<MyClasses />} />
          <Route path="assignments" element={<Assignments />} />
          <Route path="lms" element={<LMS />} />
          <Route path="timetable" element={<Timetable />} />
          <Route path="attendance" element={<Attendance />} />
          <Route path="students" element={<MyStudent />} />
          <Route path="exams" element={<Exams />} />
          <Route path="events" element={<Events />} />
          <Route path="leave-request" element={<LeaveRequest />} />
          <Route path="settings" element={<Settings />} />
        </Route>

        {/* Admin Routes */}
        <Route path="/admin">
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="students" element={<StudentList />} />
          <Route path="lms" element={<AdminLMS />} />
          <Route path="teachers" element={<TeacherList />} />
          <Route path="classes" element={<ClassManagement />} />
          <Route path="timetable" element={<AdminTimetable />} />
          <Route path="attendance" element={<AdminAttendance />} />
          <Route path="exams" element={<Examinations />} />
          <Route path="fees" element={<FeeManagement />} />
          <Route path="notices" element={<Notices />} />
          <Route path="transport" element={<Transport />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>

        {/* Accountant Routes */}
        <Route path="/accountant">
          <Route index element={<Navigate to="/accountant/dashboard" replace />} />
          <Route path="dashboard" element={<AccountantDashboard />} />
          <Route path="fees" element={<FeeCollection />} />
          <Route path="students" element={<AccountantStudents />} />
          <Route path="reports" element={<AccountantReports />} />
          <Route path="settings" element={<AccountantSettings />} />
        </Route>

        {/* Redirect unknown routes */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
